// import { register } from "swiper/element/bundle";
import $ from "jquery";
import Swal from "sweetalert2";

const utilsSweetalert2 = () => {
    const init = () => {
        execute();
    };
    
    const execute = () => {
        $(() => {
            function checkForGFormInput() {
                var gformInput = document.getElementById('gform');
                if (gformInput) {
                    // var formData = JSON.parse(gformInput.value);
                    
                    Swal.fire({
                        customClass: "swal-popup swal-popup-form-success mr-30",
                        text: 'Je hebt succesvol verzonden',
                        timer: 2000,
                        imageUrl: "/wp-content/themes/hello-theme-child-master/starter-hello-elementor-child/assets/images/ic-success_check.svg",
                        imageWidth: 20,
                        imageHeight: 20,
                        showConfirmButton: false,
                        position: "top-end",
                    })

                    gformInput.remove();
                }
            }

            // MutationObserver = watch for changes in the DOM
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.addedNodes.length) {
                        checkForGFormInput();
                    }
                });
            });

            // Observe the document
            observer.observe(document.body, { childList: true, subtree: true });

            // Initial check in case the element is already present
            checkForGFormInput();
        })
    };



    init();
};

try {
    utilsSweetalert2();
} catch (error) {
    console.error("utilsSweetalert2", error);
}
